import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'
import Login from '@/views/Login.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Login',
        component: Login
    },
    {
        path: '/home',
        name: 'Home',
        component: Home
    },
    {
        path: '/registered',
        name: 'Registered',
        component: () => import('@/views/Administrator/Registered.vue')
    },
    {
        path: '/forgotPassword',
        name: 'ForgotPassword',
        component: () => import('@/views/Administrator/ForgotPassword.vue')
    },
    {
        path: '/changePassword',
        name: 'ChangePassword',
        component: () => import('@/views/Administrator/changePassword.vue')
    },
    {
        path: '/help',
        name: 'help',
        component: () => import('@/views/Administrator/help.vue')
    },
    {
        path: '/setList',
        name: 'SetList',
        component: () => import('@/views/Administrator/setList.vue')
    },
    {
        path: '/userSet',
        name: 'UserSet',
        component: () => import('@/views/Administrator/userSet.vue')
    },
    {
        path: '/sys',
        name: 'Sys',
        component: () => import('@/views/Administrator/sys.vue')
    },
    {
        path: '/job/:tag',
        name: 'Job',
        component: () => import('@/views/Job/index.vue'),
        children: [
            {
                path: 'detail/:id',
                name: 'JobDetails',
                component: () => import('@/views/Job/detail.vue')
            },
            {
                path: 'add',
                name: 'JobAdd',
                component: () => import('@/views/Job/add.vue')
            },
            {
                path: 'edit/:id',
                name: 'JobEdit',
                component: () => import('@/views/Job/edit.vue')
            }
        ]
    },
    {
        path: '/case/:tag',
        name: 'Case',
        component: () => import('@/views/Case/index.vue'),
        children: [
            {
                path: 'detail/:id',
                name: 'CaseDetails',
                component: () => import('@/views/Case/detail.vue')
            },
            {
                path: 'add',
                name: 'CaseAdd',
                component: () => import('@/views/Case/add.vue')
            },
            {
                path: 'edit/:id',
                name: 'CaseEdit',
                component: () => import('@/views/Case/edit.vue')
            }
        ]
    },
    {
        path: '/sell/:tag',
        name: 'Sell',
        component: () => import('@/views/Sell/index.vue'),
        children: [
            {
                path: 'detail/:id',
                name: 'SellDetails',
                component: () => import('@/views/Sell/detail.vue')
            },
            {
                path: 'add',
                name: 'SellAdd',
                component: () => import('@/views/Sell/add.vue')
            },
            {
                path: 'edit/:id',
                name: 'SellEdit',
                component: () => import('@/views/Sell/edit.vue')
            }
        ]
    },
    {
        path: '/link/google',
        name: 'Google',
        component: () => import('@/views/Link/google.vue'),
    },
    {
        path: '/lottery',
        name: 'Lottery',
        component: () => import('@/views/Lottery.vue'),
    },
    {
        path: '/member/gift',
        name: 'MemberGift',
        component: () => import('@/views/Member/Gift.vue'),
    },
    {
        path: '/traffic',
        name: 'Traffic',
        component: () => import('@/views/Traffic/index.vue'),
    },
    {
        path: '/store',
        name: 'Store',
        component: () => import('@/views/Store/index.vue'),
        children: [
            {
                path: 'detail/:id',
                name: 'StoreDetails',
                component: () => import('@/views/Store/detail.vue')
            },
            {
                path: 'chatroom',
                name: 'StoreChatroomList',
                component: () => import('@/views/Store/chatroomList.vue')
            },
            {
                path: 'chatroom/:id/:channel/:showName',
                name: 'StoreChatroom',
                component: () => import('@/views/Store/chatroom.vue')
            },
            {
                path: 'car',
                name: 'StoreCar',
                component: () => import('@/views/Store/car.vue')
            },
            {
                path: 'info',
                name: 'StoreInfo',
                component: () => import('@/views/Store/info.vue')
            },
            {
                path: 'complete',
                name: 'StoreComplete',
                component: () => import('@/views/Store/complete.vue')
            },
            {
                path: 'customer/center',
                name: 'CustomerCenter',
                component: () => import('@/views/Store/customerCenter.vue')
            },
            {
                path: 'order/detail/:id',
                name: 'OrderDetail',
                component: () => import('@/views/Store/orderDetail.vue')
            },
        ],
    },
    {
        path: '/container',
        name: 'Container',
        component: () => import('@/views/Container/index.vue'),
        children: [
            {
                path: 'history',
                name: 'ContainerHistory',
                component: () => import('@/views/Container/index.vue')
            }
        ]
    },
    {
        path: '/container/add',
        name: 'ContainerAdd',
        component: () => import('@/views/Container/addEdit.vue')
    },
    {
        path: '/container/edit/:id',
        name: 'ContainerEdit',
        component: () => import('@/views/Container/addEdit.vue')
    },
    {
        path: '/container/detail/:id',
        name: 'ContainerDetail',
        component: () => import('@/views/Container/detail.vue')
    },
    {
        path: '/container/pay_page/:id',
        name: 'ContainerPayPage',
        component: () => import('@/views/Container/payPage.vue')
    },
]

const router = new VueRouter({
    mode: 'history',
    base: '/app',
    fallback: true,
    routes
});

export default router
